// @flow
import * as React from 'react';

import { localize } from '@ta/common.i18n';
import { useUpdatedMember } from '@ta/social.member-common';

import type { Profile } from './FollowAction';

type Props = {|
  profile: Profile,
  onClick?: (SyntheticEvent<HTMLSpanElement>) => mixed,
|};

const FollowText = ({ profile, onClick }: Props) => {
  const { isFollowing } = useUpdatedMember(profile);
  return (
    <span onClick={onClick}>
      {/* Unfollow/ Follow */}
      {isFollowing ? localize('social_unfollow') : localize('social_Follow')}
    </span>
  );
};

export default FollowText;
